// Components
import { MdFilterListAlt } from 'react-icons/md';
import { ImCross } from 'react-icons/im';

// Types
import { ClearFilterIconProps } from './types';

const ClearFilterIcon = ({ isFiltered, handleClearFilters }: ClearFilterIconProps) => {
  return (
    <div className="clear-filters d-flex align-items-center justify-content-center rounded-2 me-2 pt-1" onClick={() => handleClearFilters()}>
      <MdFilterListAlt color={isFiltered ? '#838383' : '#cbcbcb'} size={24} />
      <div className="clear-filter-x rounded-circle  d-flex align-items-center justify-content-center">
        <ImCross color={isFiltered ? '#dc354b' : '#cbcbcb'} size={10} />
      </div>
    </div>
  );
};

export default ClearFilterIcon;
